import { Component, OnInit, ViewChild } from '@angular/core';
import { CreateshopService } from '../createshop/createshop.service';
import { CreateShop } from '../Models/createshop.model';
import { NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { createOfflineCompileUrlResolver } from '@angular/compiler';
import { global } from '../../shared/global';
import { MouseEvent } from '@agm/core';
import { NgxSpinnerService } from 'ngx-spinner';
declare var $: any;

@Component({
  selector: 'app-createshop',
  templateUrl: './createshop.component.html',
  styleUrls: ['./createshop.component.css']
})
export class CreateshopComponent implements OnInit {

  @ViewChild('createShopForm', { static: true }) createShopForm: NgForm;

  termConditionLink: any;
  entityTitle: any;
  shopkeeperTitle: any;
  entityMessage: any;

  cookieValue: any;
  configCookie: any;
  btnName: any;
  username: any;

  data: CreateShop;
  responseData: any;
  categories: any;
  storeImage: any = '';

  lat: any;
  lng: any;
  zoom: number = 15;

  constructor(private service: CreateshopService, private router: Router, private cookieService: CookieService, private spinner: NgxSpinnerService) {
    if (navigator) {
      navigator.geolocation.getCurrentPosition(pos => {
        this.lng = +pos.coords.longitude;
        this.lat = +pos.coords.latitude;
      });
    }
  }

  ngOnInit() {
    this.termConditionLink = global.termConditionLink;

    this.data = new CreateShop();
    this.getCategory();

    this.configCookie = this.cookieService.get("config");
    if (this.configCookie) {
      this.configCookie = JSON.parse(this.configCookie);
    }

    this.cookieValue = this.cookieService.get("shop");
    if (this.cookieValue) {
      this.fillShopDetail();
      this.btnName = "Update";
      this.entityTitle = "Back to Manage Entity";
      this.entityMessage = "Entity Updated Successfully!";
      document.getElementById("divImage").style.display = "block";
      document.getElementById("divInactive").style.display = "block";
      // document.getElementById("divChat").style.display = "block";
    }
    else {
      this.btnName = "Submit";
      this.entityTitle = "Back to Create Entity";
      this.entityMessage = "Entity Created Successfully!";
      document.getElementById("divImage").style.display = "none";
      document.getElementById("divInactive").style.display = "none";
      // document.getElementById("divChat").style.display = "none";
    }
  }

  markerDragEnd($event: MouseEvent) {
    this.lat = $event.coords.lat;
    this.lng = $event.coords.lng;
  }

  getCategory() {
    this.service.getCategory()
      .subscribe(data => {
        this.categories = data;
      });
  }

  fillShopDetail() {
    this.data = JSON.parse(this.cookieValue);
    this.shopkeeperTitle = "";

    var compData = {
      "companyid": this.data.companyid
    }
    var storeData: any;

    this.service.getShopInfo(compData)
      .subscribe(shopData => {
        storeData = shopData;

        if (storeData.isSuccess == false) {
        }
        else {
          this.data = storeData.data;

          this.lat = storeData.data.latitude;
          this.lng = storeData.data.longitude;
          this.data.confirmPassword = storeData.data.password;

          this.data.start_time = storeData.data.start_time.slice(0, 5);
          this.data.end_time = storeData.data.end_time.slice(0, 5);

          this.data.is_break_available = (storeData.data.is_break_available == 1 ? true : false);
          this.divDisplay(!this.data.is_break_available);

          if (storeData.data.is_break_available == 1) {
            this.data.break_start_time = storeData.data.break_start_time.slice(0, 5);
            this.data.break_end_time = storeData.data.break_end_time.slice(0, 5);
          } else {
            this.data.break_start_time = "";
            this.data.break_end_time = "";
          }

          this.storeImage = global.imageUrl + this.data.companyid;
          this.data.imageFilePath = global.imageUrl + this.data.companyid;

          this.shopkeeperTitle = storeData.data.name;

          this.data.autocall = (storeData.data.autocall == 1 ? true : false);
          this.data.deliver_to_customer = (storeData.data.deliver_to_customer == 1 ? true : false);

          this.data.customer_register = (storeData.data.customer_register == 1 ? true : false);
        }
      });
  }

  onSubmit(createshop: CreateShop) {
    if (this.createShopForm.valid) {
      this.spinner.show();
      var saveData = {
        "maincompanyid": createshop.maincompanyid,
        "pincode": createshop.pincode,
        "address": createshop.address,
        "break_start_time": (createshop.is_break_available ? createshop.break_start_time : "00:00:00"),
        "token_per_hour": createshop.token_per_hour,
        "latitude": this.lat,
        "mobile": createshop.mobile,
        "end_time": createshop.end_time,
        "autocall": (createshop.autocall ? "1" : "0"),
        "start_time": createshop.start_time,
        "password": createshop.password,
        "companyid": (this.cookieValue ? createshop.companyid : "0"),
        "is_break_available": (createshop.is_break_available ? "1" : "0"),
        "name": createshop.name,
        "email": createshop.email,
        "break_end_time": (createshop.is_break_available ? createshop.break_end_time : "00:00:00"),
        "isUpdate": (this.cookieValue ? "1" : "0"),
        "longitude": this.lng,
        "area": createshop.area,
        "deliver_to_customer": (createshop.deliver_to_customer ? "1" : "0"),
        "customer_register": (createshop.customer_register ? "1" : "0")
      };

      this.service.insertShopDetail(saveData)
        .subscribe(data => {
          this.responseData = data;
          if (this.responseData.isSuccess == false) {
          }
          else {
            // var obj = {
            //   "latitude": this.lat + ',' + this.lng,
            //   "confirmPassword": createshop.password,
            //   "asccode": this.responseData.asccode,
            //   "companyid": this.responseData.companyid,
            //   "is_break_available": createshop.is_break_available,
            //   "deliver_to_customer": createshop.deliver_to_customer,
            //   "autocall": createshop.autocall,
            // }
            // saveData = Object.assign(saveData, obj);
            var objStoreData = {
              "companyid": this.responseData.companyid,
              "asccode": this.responseData.asccode,
              "customer_register":this.responseData.customer_register
            }
            this.username = this.responseData.asccode;
            // this.cookieService.set("shop", JSON.stringify(saveData));

            // Start --> Save Image
            if (this.cookieValue) {
              const formData = new FormData();
              formData.append("storeid", createshop.companyid);
              formData.append("file", this.storeImage);
              this.service.saveStoreImage(formData)
                .subscribe(data => {
                  this.responseData = data;
                  if (this.responseData.isSuccess == false) {
                  } else {
                  }
                });
            }
            // End

            // this.cookieService.set("shop", JSON.stringify(saveData));
            this.cookieService.set("shop", JSON.stringify(objStoreData));
            this.spinner.hide();
            this.displayModal();
          }
        });
    }
    else {
      console.log("Not Valid Data");
    }
  }

  displayModal() {
    $('#createShopModal').modal('show');
    // setTimeout(() => {
    //   $('#createShopModal').modal('hide');
    //   this.router.navigate(["/shopkeeper"]);
    // }, 5000);
  }

  closeModal() {
    this.router.navigate(["/shopkeeper"]);
  }

  divDisplay(chkValue) {
    if (!chkValue) {
      this.createShopForm.controls["break_start_time"].enable();
      this.createShopForm.controls["break_end_time"].enable();

      document.getElementById("divBreak").style.display = "block";
    } else {
      this.createShopForm.controls["break_start_time"].disable();
      this.createShopForm.controls["break_end_time"].disable();

      document.getElementById("divBreak").style.display = "none";
    }
  }

  uploadStudImage(event) {
    this.data.imageFilePath = "";
    if (event.target.files.length > 0) {
      const [file] = event.target.files;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.data.imageFilePath = reader.result as string;
      }
      this.storeImage = event.target.files[0];
    }
    else {
      this.storeImage = "";
    }
  }

  inactiveEntity() {
    this.data = JSON.parse(this.cookieValue);

    var compData = {
      "companyid": this.data.companyid
    }
    var storeData: any;

    this.service.inactiveShop(compData)
      .subscribe(shopData => {
        storeData = shopData;
        if (storeData.isSuccess == false) {
        }
        else {
          this.cookieService.delete("shop");
          this.router.navigate(["/shopkeeper"]);
        }
      });
  }

  logout() {
    if (this.configCookie.isStaff == 1) {
      this.cookieService.delete("staff");
    } else {
      this.cookieService.delete("shop");
    }
    this.cookieService.delete("config");
    this.router.navigate(["/login"]);
  }
}